import { useAppliedFilterStore } from "../store/filtersv2";
import { DealerData } from "../types";
import { useDealersStore } from "./use-dealers-store";

export const getSingleSelectedDealer = () => {
  const { allDealers: all_dealers } = useDealersStore();
  const { applied } = useAppliedFilterStore();
  const { dealer } = applied;

  if (dealer?.length && dealer?.length === 1) {
    return (all_dealers as DealerData[])?.find(d => d.static_dealer_id === dealer[0]);
  }

  return;
}
